import { useState } from 'react';
import { apiFetch } from '../api';

function DataExport() {
  const [exporting, setExporting] = useState(null);
  const [snapshotStart, setSnapshotStart] = useState(() => {
    const d = new Date(); d.setDate(d.getDate() - 90);
    return d.toISOString().slice(0, 10);
  });
  const [snapshotEnd, setSnapshotEnd] = useState(() => new Date().toISOString().slice(0, 10));

  async function exportFile(type, url) {
    setExporting(type);
    try {
      const res = await apiFetch(url);
      if (res.ok) {
        const blob = await res.blob();
        const disposition = res.headers.get('content-disposition');
        const filename = disposition?.match(/filename=(.+)/)?.[1] || `${type}-export.csv`;
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setExporting(null);
    }
  }

  return (
    <section className="card">
      <h2>Data Export</h2>
      <div className="de-export-list">
        <div className="de-export-row">
          <div>
            <strong>Transactions</strong>
            <p style={{ color: '#71717a', fontSize: 13, margin: '4px 0 0' }}>All transactions with categories, memos, and review status</p>
          </div>
          <button className="manage-btn" onClick={() => exportFile('transactions', '/api/export/transactions')} disabled={exporting === 'transactions'}>
            {exporting === 'transactions' ? 'Exporting...' : 'Export CSV'}
          </button>
        </div>
        <div className="de-export-row">
          <div>
            <strong>Accounts</strong>
            <p style={{ color: '#71717a', fontSize: 13, margin: '4px 0 0' }}>Current account balances and categories</p>
          </div>
          <button className="manage-btn" onClick={() => exportFile('accounts', '/api/export/accounts')} disabled={exporting === 'accounts'}>
            {exporting === 'accounts' ? 'Exporting...' : 'Export CSV'}
          </button>
        </div>
        <div className="de-export-row">
          <div>
            <strong>Balance Snapshots</strong>
            <p style={{ color: '#71717a', fontSize: 13, margin: '4px 0 0' }}>Daily account balance history</p>
            <div style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center' }}>
              <input type="date" value={snapshotStart} onChange={(e) => setSnapshotStart(e.target.value)}
                style={{ padding: '4px 8px', background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, fontSize: 13 }} />
              <span style={{ color: '#71717a' }}>to</span>
              <input type="date" value={snapshotEnd} onChange={(e) => setSnapshotEnd(e.target.value)}
                style={{ padding: '4px 8px', background: '#1a1b23', color: '#e4e4e7', border: '1px solid #3a3b45', borderRadius: 6, fontSize: 13 }} />
            </div>
          </div>
          <button className="manage-btn" onClick={() => exportFile('snapshots', `/api/export/snapshots?start=${snapshotStart}&end=${snapshotEnd}`)} disabled={exporting === 'snapshots'}>
            {exporting === 'snapshots' ? 'Exporting...' : 'Export CSV'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default DataExport;
